
import mixin from "./mixin";
import notifications from "@/lib/notifications";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import { Component, Mixins } from "vue-property-decorator";
import * as modals from "@/lib/modals";
import { onlyWhiteSpace } from "@/lib/utilities";
import NoteFields from "@/components/widgets/NoteFields.vue";

@Component({
  name: modals.cancelOrderModal,
  components: {
    NoteFields
  }
})
export default class CancelOrderModal extends Mixins(mixin) {
  orderModule: OrderModule = getModule(OrderModule);
  note: any = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
  orderNumber: number = null;
  cancelling: boolean = false;

  get title() {
    return `Cancel Order - ${this.orderNumber}`;
  }

  get deliveryForId () {
    if(this.selectedItems == null || this.selectedItems.length == 0)
      return null;
    return this.selectedItems[0].deliveryForId ?? 0;
  }

  get canCancel() {
    return (
      !this.modalData?.noteIsRequired ||
      (!!this.note && this.note.text && !onlyWhiteSpace(this.note.text))
    );
  }

  load() {
    this.show();
    this.orderNumber =
      this.selectedItems && this.selectedItems.length > 0 ? this.selectedItems[0].number : 0;
  }

  noteUpdated(newNote) {
    this.note = JSON.parse(JSON.stringify(newNote));
  }

  async saveModal() {
    try {
      this.cancelling = true;
      await this.orderModule.cancelOrder({
        orderNumber: this.orderNumber,
        orderNote: this.note
      });

      for (let index = 0; index < this.selectedItems.length; index++) {
        const selectedOrder = this.selectedItems[index];

        let note = {
          orderHeaderNumber: parseInt(selectedOrder.number),
          text: this.note.text,
          facilityViewable:
            this.note.facilityViewable !== undefined ? this.note.facilityViewable : true,
          customerViewable:
            this.note.customerViewable !== undefined ? this.note.customerViewable : true,
          isLegacy: false
        };

        let action = this.orderModule.createOrderNotes;

        try {
          await action(note);

          this.addActionResult({
            number: selectedOrder.number,
            success: true,
            message: `Note added to order ${selectedOrder.number}.`
          });
        } catch (error) {
          this.addActionResult({
            number: selectedOrder.number,
            success: false,
            message: error.response.data.message,
            errors:
              error.response.data && error.response.data.errors ? error.response.data.errors : null,
            errorMessages:
              error.response.data && error.response.data.errorMessages
                ? error.response.data.errorMessages
                : null
          });
        }
      }
      notifications.success("Order Cancelled", `Order ${this.orderNumber} successfully cancelled`);
      this.hideModal();
    } catch (ex) {
      notifications.error("Cancel Order", `Failed to cancel order ${this.orderNumber}`, ex);
    } finally {
      this.cancelling = false;
    }

    this.refreshOrders();
  }
}
